export default __webpack_public_path__ + "static/media/fact_sheet42.aa448e59.png";